import { Plugin } from 'prosemirror-state';
import { FILE_UPLOAD_LIMIT } from 'shared/constants';

export const uploadImagePlugin = (uploader, hasStorage, imageTypes, eventBus) => new Plugin({
  props: {
    handleDOMEvents: {
      drop(view, event) {
        const hasFiles = event.dataTransfer.files.length > 0;
        if (!hasFiles) {
          return;
        }

        const files = Array.from(event.dataTransfer.files);
        const images = files.filter((i) => imageTypes.includes(i.type));

        if (images.length === 0) {
          return;
        }

        if (images.length === files.length) {
          event.preventDefault();
        }

        const { schema } = view.state;
        const coordinates = view.posAtCoords({
          left: event.clientX,
          top: event.clientY,
        });
        let pos = coordinates.pos - 1;
        if (pos < 0) {
          pos = 0;
        }

        if (!hasStorage) {
          eventBus.emit('show-toast', {
            color: 'warning',
            message: 'Your storage is full. Please upgrade to upload more images.',
          });
          return;
        }

        images.forEach((image) => {
          if (!imageTypes.includes(image.type)) {
            return;
          }

          if (image.size > FILE_UPLOAD_LIMIT) {
            eventBus.emit('show-toast', {
              color: 'error',
              message: 'File is too big',
            });
            return;
          }

          const node = schema.nodes.image.create({
            src: '',
            size: image.size,
            name: image.name,
            image,
          });
          const transaction = view.state.tr.insert(pos, node);
          view.dispatch(transaction);

          pos += 1;
        });
      },
    },
  },
});
